import axios from "@/libs/axios";

export default {
    namespaced: true,
    state: {
        show: false,
        products: [],
        selectedProducts: [],
        filter: {
            id: '',
            name: '',
            barcode: '',
            sub_product_id: '',
            sub_product_barcode: '',
            sub_product_name: '',
            ty_merchant_id: '',
            ty_merchant_sku: '',
            limit: 10,
            brand_id: [],
            page: 1,
            sorting: 'DESC'
        }
    },
    getters: {
        _show(state) {
            return state.show
        },
        _products(state) {
            return state.products
        },
        _selectedProducts(state) {
            return state.selectedProducts
        }
    },
    mutations: {
        setProducts(state, products) {
            state.products = products
        },
        filterClear(state) {
            state.filter = {
                id: '',
                name: '',
                barcode: '',
                sub_product_id: '',
                sub_product_barcode: '',
                sub_product_name: '',
                ty_merchant_id: '',
                ty_merchant_sku: '',
                limit: 10,
                brand_id: [],
                page: 1,
                sorting: 'DESC'
            }
        }
    },
    actions: {
        getProducts(context) {
            context.state.show = true;
            context.commit('setProducts', [])
            return axios.get('/v2/products/products', {params: context.state.filter})
                .then(res => {
                    context.commit('setProducts', res.data.content.data)
                })
                .catch(error => {
                    alert('Ürün çekme hatası: ' + (error.response?.data?.message || error.message || 'Bilinmeyen hata'));
                })
                .finally(() => {
                    context.state.show = false
                })
        }
    }
}